import RequestError from './RequestError';

class ApiRequestError extends RequestError {
    /**
     * @param {Response} response 
     * @param {*} json 
     * @param {string} [msg]
     */
    constructor(response, json, msg) {
        super(response, msg);
        this.json = json;
        this.name = "ApiRequestError";
    }

    toUserString() {
        return `${this.response.status}-${this.json.code || this.json.error || "u42"}`;
    }

    /**
     * @param {*} error 
     */
    static parseToUserString(error) {
        /** @type {ApiRequestError} */
        let apiError = error;

        if (!(error instanceof ApiRequestError)) {
            apiError = new ApiRequestError(
                new Response(null, {status: 0}),
                {code: typeof(error)},
                `${error}`
            );
        }

        return apiError.toUserString();
    }
}

export default ApiRequestError;